import { RotateCcw, Search } from "lucide-react";
import { EMPTY_FILTERS, RANGES, STATUS, niceDate } from "@/lib/scoring";

const ctl = "rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-[#0B0F19] outline-none focus:border-[#2563EB]";

// Date range + (optionally) search, age, program and group filters shared by leaderboards and player analytics.
export default function StatsFilters({ f, setF, meta, full = true, idp = "stats" }) {
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const toggleGroup = (id) => set("group_ids", f.group_ids.includes(id) ? f.group_ids.filter((g) => g !== id) : [...f.group_ids, id]);
  return (
    <div data-testid={`${idp}-filters`} className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {full && (
          <label className="relative flex-1 min-w-[180px]">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input data-testid={`${idp}-search`} value={f.q} onChange={(e) => set("q", e.target.value)} placeholder="Search player" className={`${ctl} w-full pl-9`} />
          </label>
        )}
        <select data-testid={`${idp}-range`} value={f.range} onChange={(e) => set("range", e.target.value)} className={ctl}>
          {RANGES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        {f.range === "session" && (
          <select data-testid={`${idp}-session`} value={f.session_id} onChange={(e) => set("session_id", e.target.value)} className={`${ctl} max-w-xs`}>
            <option value="">Choose a session…</option>
            {(meta?.sessions || []).map((s) => <option key={s.id} value={s.id}>{niceDate(s.date)} · {s.name}{s.status !== "closed" ? ` (${STATUS[s.status]})` : ""}</option>)}
          </select>
        )}
        {f.range === "custom" && <>
          <input data-testid={`${idp}-start`} type="date" value={f.start} onChange={(e) => set("start", e.target.value)} className={ctl} />
          <input data-testid={`${idp}-end`} type="date" value={f.end} onChange={(e) => set("end", e.target.value)} className={ctl} />
        </>}
        {full && <>
          <select data-testid={`${idp}-division`} value={f.division} onChange={(e) => set("division", e.target.value)} className={ctl}>
            <option value="">All ages</option>{(meta?.divisions || []).map((d) => <option key={d}>{d}</option>)}
          </select>
          <select data-testid={`${idp}-program`} value={f.program_id} onChange={(e) => set("program_id", e.target.value)} className={`${ctl} max-w-[220px]`}>
            <option value="">All programs</option>{(meta?.programs || []).map((p) => <option key={p.id} value={p.id}>{p.title}{p.age_group ? ` · ${p.age_group}` : ""}</option>)}
          </select>
        </>}
        <button data-testid={`${idp}-reset`} onClick={() => setF({ ...EMPTY_FILTERS })} className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 px-3 py-2.5 text-sm font-bold text-slate-600 hover:text-[#0B0F19] transition-colors"><RotateCcw size={14} /> Reset</button>
      </div>
      {full && !!meta?.groups?.length && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Groups</span>
          <button data-testid={`${idp}-group-all`} onClick={() => set("group_ids", [])} className={`rounded-full px-3 py-1 text-xs font-bold transition-colors ${!f.group_ids.length ? "bg-[#0B0F19] text-white" : "border border-slate-200 text-slate-600"}`}>All players</button>
          {meta.groups.map((g) => (
            <button key={g.id} data-testid={`${idp}-group-${g.id}`} onClick={() => toggleGroup(g.id)} className={`rounded-full px-3 py-1 text-xs font-bold transition-colors ${f.group_ids.includes(g.id) ? "bg-[#2563EB] text-white" : "border border-slate-200 text-slate-600 hover:border-slate-400"}`}>{g.name}</button>
          ))}
        </div>
      )}
    </div>
  );
}
